<template>
  <div id="childAdd">
    <template v-if="isDisplayLocation">
      <v-layout class="flex-column">
        <v-layout class="mt-2 mb-3">
          <v-flex>
            <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="isDisplayLocation = false">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="isDisplayLocation = false">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
          </v-flex>
        </v-layout>
        
        <v-layout class="flex-column px-2">
          <h3 class="mt-4 pf-font-16 font-weight-bold">Display Locations</h3>
          <v-layout wrap>
            <v-flex sm3>
              <v-select v-model="displayState" label="Filter by state" :items="[...['All'], ...displayedStates]" @change="filterDisplayLocations"></v-select>
            </v-flex>
          </v-layout>
          <v-data-table :headers="displayLocationHeaders" :items="displayLocations" class="mt-4 pf-data-table">
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.address && props.item.address.length ? props.item.address[0].state.name : '--' }}</td>
              <td>
                <a v-if="props.item.website" :href="`${props.item.website.indexOf('http') === -1 ? 'https://' : ''}${props.item.website}`" target="_blank">{{ props.item.website }}</a>
                <span v-else>--</span>
              </td>
              <!-- <td>
                <v-select
                :disabled="props.item.is_owner"
                v-model="props.item.other_children.find(x => x.child === child.id).status"
                :items="['Disabled', 'Enabled']"
                @change="changeDisplayStatus(props.item)"
                :readonly="readonly"
                ></v-select>
              </td> -->
            </template>
        
          </v-data-table>
        </v-layout>
      </v-layout>
    </template>
    <template v-else-if="isDisplayInquiries">
      <child-inquiries :child="child" :data="(child.type === 'Individual' ? inquiriesBackup : getSiblingInquiries())" @back="isDisplayInquiries = false" />
    </template>
    <template v-else>
      <!-- Save/Cancel Buttons -->
      <v-layout v-if="child.type !== 'Individual' && !singleChild" class="my-2">
        <v-flex>
          <v-btn fab absolute left class="ml-3 pf-btn-fab" to="/children">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="text-xs-right mb-2">
          <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" to="/children">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn :disabled="!selectedData && groupCurrentPage === groupLastPage" class="pf-btn pf-bg-teal border-radius-10 box-shadow-none" @click="childId ? update() : save()" v-if="!readonly || groupCurrentPage !== 2">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>{{ groupCurrentPage === 2 ? 'Save' : 'Next' }}</div>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex v-if="readonly" class="font-weight-light pf-text-warning my-3 mx-4">
        <p>* This child belongs to another organization, you can only view the information.</p>
      </v-flex>

      <v-flex class="px-3 pt-3 flex-row" v-if="child.type === 'Sibling' && !singleChild">
        <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Choose a child type</h3>
        <v-radio-group v-model="child.type" row class="ma-0 px-2" @change="changedChildType" :readonly="readonly">
          <v-radio v-for="(type, j) in childrenTypes" :key="j" :label="`${type.text}`" :value="type.value" color="teal"></v-radio>
        </v-radio-group>
      </v-flex>
      <template v-if="singleChild">
        <v-layout class="pa-3 flex-column">
          <SingleChild
            v-if="currentChild"
            :parentData="child"
            @onChange="changedData"
            :child="currentChild"
            @goBack="cancelViewChild"
            @onSave="saveCurrentChild"
            @onSubmit="save"
            @avatarChange="addProfileImage"
            @uploadPhotos="addImage"
            :individualPhotos="individualPhotos"
            @fetchPhotos="fetchPhotos"
            @changedChildType="changedChildType"
            @fetchChildVideos="fetchChildVideos"
            :video="video"
            :individualVideos="individualVideos"
            :getIdFromURL="getIdFromURL"
            @addVideo="addVideo"
            @editVideo="editVideo"
            :currentEditVideo="currentEditVideo"
            @cancelVideoEdit="cancelVideoEdit"
            :isVideoCaptionEdit="isVideoCaptionEdit"
            @deleteVideo="deleteVideo"
            @updateVideoTitle="updateVideoTitle"
            @agencyDataChanged="isAgencyContactInfoChanged = true"
            :videoLinkRule="videoLinkRule"
            :displayLocationsList="displayLocationsBackup"
            :inquiryList="inquiriesBackup"
            :additionalInfo="newChild.additional_info"
            :professionalContact="child.contact"
            :websiteContact="child.website_contact"
          />
        </v-layout>
      </template>
      <v-layout v-else class="flex-column mx-3">
          
        <v-layout wrap class="mt-2 flex-end-end" v-if="child.type === 'Sibling'">
          <v-flex sm4 class="my-2">
            <v-text-field v-model.trim="child.name" :rules="rulesName" label="Enter sibling group name" class="px-2 required" @input="changedData" :readonly="readonly"></v-text-field>
          </v-flex>
          <v-flex sm3 class="my-2">
            <v-text-field label="Case ID (optional)" v-model="child.case_id" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
          </v-flex>
          <v-flex sm2 class="my-2 flex-column">
            <div class="cursor-pointer flex-align-center" @click="showDisplayLocations">
              <v-icon class="pf-text-teal mr-2" size="24">pin_drop</v-icon>
              <span class="pf-text-teal">Display Locations ({{ displayLocationsBackup.length || 0 }})</span>
            </div>
            <div class="mt-2 cursor-pointer flex-align-center" @click="showInquiries">
              <v-icon class="pf-text-teal mr-2" size="24">sms</v-icon>
              <span class="pf-text-teal">Inquiries ({{ (child.type === 'Individual' ? inquiriesBackup.length : getSiblingInquiryCount()) || 0 }})</span>
            </div>
          </v-flex>
          <v-flex sm3 class="flex-center">
            <v-flex class="flex-center flex-column" v-if="childId">
              <v-hover v-slot="{ hover: groupAvatarHover }">
                <div style="position:relative" class="border-radius-15 my-2">
                  <img v-if="child.avatar" class="border-radius-15" width="200" :src="child.avatar.replace('/thumb/', '/original/')" />
                  <img v-else class="border-radius-15" width="200" src="/static/profile-pic.jpg" />
                  <div v-if="!readonly && groupAvatarHover" class="border-radius-15 flex-center avatar-overlay" @click="addProfileImage('group')">
                    <v-icon size="25" color="white">photo_camera</v-icon>
                  </div>
                </div>
              </v-hover>
              <span>Group Photo</span>
            </v-flex>
          </v-flex>
        </v-layout>

        <template v-if="child.type === 'Sibling'">
          <v-flex class="child-section-header pf-bg-light-3 mt-4 py-4 px-3 flex-center border-radius-10">
            <span class="text-uppercase font-weight-bold pf-font-16">{{ mainTab === 'general' ? 'General Information' : 'Contact Information' }}</span>
          </v-flex>
          <v-layout class="mt-4">
            <v-flex class="flex-space-around">
              <div class="flex-column flex-center cursor-pointer" @click="switchTabs('general', 1)">
                <v-icon :color="mainTab === 'general' ? 'white' : 'black'" :class="{ 'pf-bg-teal': mainTab === 'general' }" class="pf-bg-light pa-3 border-radius-30 mb-2" size="20">settings</v-icon>
                <span :class="{ 'font-weight-bold': mainTab === 'general' }">General Info</span>
              </div>
              <div class="flex-column flex-center cursor-pointer" @click="switchTabs('contact', 2)">
                <v-icon :color="mainTab === 'contact' ? 'white' : 'black'" :class="{ 'pf-bg-teal': mainTab === 'contact' }" class="pf-bg-light pa-3 border-radius-30 mb-2" size="20">contacts</v-icon>
                <span :class="{ 'font-weight-bold': mainTab === 'contact' }">Contact</span>
              </div>
            </v-flex>
          </v-layout>

          <!-- Sections -->
          <v-layout v-if="mainTab === 'general'" class="mt-4 flex-column">

            <v-form ref="ChildInfo">
              
              <v-layout wrap>
                <v-flex class="xs12 sm4 my-2">
                  <v-text-field label="City" class="px-2" v-model.trim="child.jurisdiction.city" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex class="xs12 sm4 my-2">
                  <v-text-field label="County" class="px-2" v-model.trim="child.jurisdiction.county" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex class="xs12 sm4 my-2">
                  <v-select class="px-2" v-model="child.status.status" label="Status" :items="childStatuses" @change="changedData" :readonly="readonly"></v-select>
                </v-flex>
                <v-flex class="xs12 sm4 my-2">
                  <v-select class="px-2" v-model="child.placement" label="Placement" :items="placementTypes" @change="placementChanged" :readonly="readonly"></v-select>
                </v-flex>
                <v-flex class="xs12 sm4 my-2" v-if="['selectedStates', 'inState'].indexOf(child.placement) > -1">
                  <v-autocomplete label="Select the States" :disabled="child.placement === 'inState'" class="px-2" :items="filteredStates" item-value="id" item-text="name" v-model="child.display_on_states" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                </v-flex>
              </v-layout>

              <v-layout class="mt-5 flex-column">
                <h3 class="px-2 pf-font-16 font-weight-bold">Describe the family composition best suited for this sibling</h3>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="my-2">
                    <v-select class="px-2" v-model="child.preference.parent_type" label="Parent type (select all that apply)" multiple small-chips deletable-chips :items="parentTypes" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 class="my-2">
                    <v-select class="px-2" v-model="child.preference.other_children" label="Other children" :items="otherChildren" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-select class="px-2" v-model="child.preference.gender" label="Gender" :items="prefGenders" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-select class="px-2" v-model="child.preference.age" label="Age" :items="prefAges" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-select class="px-2" v-model="child.preference.religion" label="Religious preference" :items="prefReligions" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                </v-layout>
              </v-layout>
              
              <!-- Children list / Add -->
              <v-layout class="flex-column">
                <v-flex v-if="!readonly && child.type === 'Sibling'" class="mt-4">
                  <v-btn class="border-radius-15 pf-btn pf-btn-save pf-bg-teal" @click="addChild">
                    <v-icon size="18" class="pr-2">add</v-icon>
                    <div>Child</div>
                  </v-btn>
                </v-flex>
                <!-- List -->
                <v-layout wrap class="mt-4">
                  <v-flex sm3 v-for="(childItem, c) in child.children" :key="c" class="pa-2">
                    <div class="pf-bg-light-2 pa-2 border-radius-10 cursor-pointer" @click="viewChild(childItem, c)">
                      <v-layout wrap>
                        <v-flex xs4 class="flex-center">
                          <img v-if="!!childItem.avatar" :src="`${childItem.avatar}`" width="100%" class="border-radius-5">
                          <img v-else src="/static/profile-pic.jpg" width="100%" class="border-radius-5">
                        </v-flex>
                        <v-flex xs8 class="flex-end-space-between flex-column">
                          <div class="flex-start-start flex-column pf-width-100p px-2">
                            <span class="font-weight-medium pf-font-12">{{ childItem.human[0].first_name || 'New Child' }}</span>
                            <span v-if="typeof childItem.human[0].age !== 'undefined'" class="font-weight-medium pf-font-12"><span class="font-weight-light">Age:</span> {{ childItem.human[0].age }} Yrs</span>
                          </div>
                          <v-icon v-if="!readonly && child.children.length > 1" size="22" class="pf-text-dark" title="Remove" @click.stop="removeChild(c)">delete_outline</v-icon>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
    
              <v-layout class="mt-4 flex-column">
                <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Description</h3>
                <v-flex sm12 class="px-2">
                  <editor :options="editorOption" v-model="child.description" :content="aboutContent" :init="init" :api-key="config.tinymceEditorKey" @input="changedData" :disabled="readonly" />
                </v-flex>
              </v-layout>
      
              <v-layout class="pa-1 mt-4 flex-column" v-if="childId">
                <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Photos</h3>
                <v-layout wrap class="px-2" v-if="!readonly">
                  <v-flex xs10 class="pf-border-grey-dash-1 border-radius-15 pa-2 flex-center cursor-pointer" @click="addImage('group')">
                    <v-flex class="flex-center flex-column">
                      <v-icon size="28" color="grey">add_photo_alternate</v-icon>
                      <span>Click here to upload</span>
                    </v-flex>
                  </v-flex>
                  <v-flex xs2 class="pl-3">
                    <v-flex class="flex-center pf-bg-teal border-radius-25 pa-4 cursor-pointer" @click="addImage('group')">
                      <v-icon size="40" color="white">upload</v-icon>
                    </v-flex>
                  </v-flex>
                </v-layout>
    
                <!-- List photos -->
                <v-layout class="mt-2">
                  <isotope ref="groupImages" v-if="groupPhotos.length" :options="getOptions()" v-images-loaded:on.progress="layout" :list="groupPhotos" class="pf-width-100p">
                    <v-flex v-for="(photo, p) in groupPhotos" :key="p" class="pa-2 photo-item xs6 sm3 md2">
                      <div class="border-radius-5 pf-cursor-pointer pf-pos-relative flex-center">
                        <v-card class="border-radius-5 pf-box-shadow">
                          <v-hover v-slot="{ hover: imageHover }">
                            <div class="pf-pos-relative">
                              <img class="pf-width-100p" :src="`${photo.thumb_url ? photo.thumb_url : photo.webview_url ? photo.webview_url : photo.original_url}`" :alt="photo.caption">
                              <v-btn absolute v-if="!readonly && imageHover && photo.status !== 'Approved'" title="Remove photo" icon flat @click.stop="deletePhoto(photo)" class="white top-right">
                                <v-icon class="pf-text-teal" size="18">delete</v-icon>
                              </v-btn>
                            </div>
                          </v-hover>
                          <v-layout class="wrap flex-center">
                            <v-flex xs10 class="pa-1 flex-start">
                              <span v-if="!isCaptionEdit || currentEditPhoto !== photo.id" class="pf-font-12 pa-1 font-weight-regular">{{photo.caption || 'No Caption'}}</span>
                              <v-text-field v-if="isCaptionEdit && currentEditPhoto === photo.id" v-model.trim="photo.caption" autofocus :hide-details="true" class="pf-font-12 ma-0 pa-0" height="20" @keyup.enter.prevent="{}" @change="savePhotoCaption" :readonly="readonly"></v-text-field>
                            </v-flex>
                            <v-flex xs2 class="text-center pa-1">
                              <v-icon class="pf-text-teal" size="16" @click.stop="editPhotoCaption(photo, p)" v-if="!readonly && (!isCaptionEdit || currentEditPhoto !== photo.id)">edit</v-icon>
                              <v-icon class="pf-text-teal" size="16" @click.stop="isCaptionEdit = false" v-else-if="!readonly">done</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>
                    </v-flex>
                  </isotope>
                  <v-flex v-else class="font-weight-normal my-3 mx-4">
                    <p>No photos found</p>
                  </v-flex>
                </v-layout>
    
              </v-layout>

            </v-form>

            <v-layout v-if="childId">
              <!-- Videos -->
              <v-layout class="flex-column mt-4">
                <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Videos</h3>
                <v-form ref="videoAddForm" v-if="!readonly">
                  <v-layout wrap class="px-2">
                    <v-flex xs10 sm6>
                      <v-text-field label="Provide YouTube or Vimeo video link" v-model="video.url" :rules="[videoLinkRule]" :readonly="readonly"></v-text-field>
                    </v-flex>
                    <v-flex xs2 sm2>
                      <v-btn class="border-radius-15 pf-btn pf-btn-save pf-bg-teal" @click="addVideo">
                        <v-icon size="18" class="pr-2">add</v-icon>
                        <div>Add</div>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-layout wrap class="mt-3">
                  <v-flex xs12 sm3 v-for="videoItem of groupVideos" :key="videoItem.id" pa-2 class="video-listing">
                    <v-card v-if="videoItem.url" height="100%" class="pf-pos-relative">
                      <youtube v-if="videoItem.type === 'Youtube'" class="youtube-player" :video-id="getIdFromURL(videoItem.url)">
                      </youtube>
                      <vimeo-player v-else-if="videoItem.type === 'Vimeo'" :video-url="videoItem.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>
                      <video v-else playsinline controls height="150" width="100%">
                        <source :src="videoItem.url" />
                      </video>
                      
                      <v-flex class="pl-1 pr-1 mb-0">
                        <h5 v-if="!isVideoCaptionEdit || currentEditVideo != videoItem.id" id="videoName" class="pa-1 title-display">
                          <div v-on:click="!readonly ? editVideo(videoItem, videoItem.id) : {}">
                            <span v-if="videoItem.name">{{ videoItem.name }}</span>
                            <span v-else>Add title here</span>
                          </div>
                        </h5>
                        <v-text-field 
                          v-if="!readonly && isVideoCaptionEdit && currentEditVideo == videoItem.id" 
                          v-model.trim="videoItem.name"
                          autofocus 
                          :hide-details="true"
                          class="pr-1 pt-1 text-edit-field" 
                          height="20" 
                          placeholder="Add title here"
                          @change="updateVideoTitle('group')">
                        </v-text-field>
                      </v-flex>
                      <v-divider horizontal></v-divider>
                      <v-flex flat class="text-xs-right pa-1" v-if="!readonly">
                        
                        <v-btn icon title="Cancel Edit" class="ma-0 handle" v-show="isVideoCaptionEdit && currentEditVideo == videoItem.id" @click="cancelVideoEdit">
                          <v-icon size="22" color="grey darken-2">cancel</v-icon>
                        </v-btn>
                        <v-btn icon title="Edit" class="ma-0" :disabled="isVideoCaptionEdit && currentEditVideo == videoItem.id" @click="editVideo(videoItem, videoItem.id)">
                          <v-icon size="22" color="grey darken-2">edit</v-icon>
                        </v-btn>
                        <v-btn icon title="Delete" class="ma-0" v-on:click="deleteVideo(videoItem);">
                          <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                        </v-btn>
                      </v-flex>
                      
                    </v-card>
                  </v-flex>
                  <v-flex v-if="!groupVideos.length" class="font-weight-normal my-3 mx-4">
                    <p>No videos found</p>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-layout>

          </v-layout>
    
          <v-layout v-else-if="mainTab === 'contact'" class="mt-5 flex-column">

            <h3 class="px-2 pf-font-16 font-weight-bold">Professional Inquire</h3>

            <v-form ref="ChildContact">
              <v-layout wrap>
                <v-flex xs12 sm4 class="my-2">
                  <v-text-field v-model.trim="child.contact.name" :rules="[rules.required]" label="Contact Name" class="required px-2" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="my-2">
                  <v-text-field v-model.trim="child.contact.organization" label="Organization" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="my-2">
                  <v-text-field v-mask="'(###) ###-####'" placeholder="(###) ###-####" label="Phone Number"
                    v-model.trim="child.contact.phone" @input="changedData" :rules="[rules.phoneRules]" class="px-2" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="my-2">
                  <v-text-field label="Email Address" v-model="child.contact.email" class="required px-2" :rules="[rules.required, rules.emailRules]" v-validate="'required'" data-vv-name="emailAddress" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="my-2">
                  <v-text-field label="Website URL" hint="Ex: https://example.com, http://example.com" v-model="child.contact.website" class="px-2" :rules="rules.websiteRules" data-vv-name="websiteAddress" @input="changedData" :readonly="readonly"></v-text-field>
                </v-flex>
              </v-layout>
      
              <v-layout class="mt-5 flex-column">
                <h3 class="px-2 pf-font-16 font-weight-bold">Website Inquire</h3>
                <v-layout wrap>
                  <v-flex xs12 sm8 class="my-2">
                    <div class="mt-3 font-weight-light px-2 pf-text-16" v-if="session.role() !== 'admin'">{{ child.agency.name }}</div>
                    <v-autocomplete v-else label="Organization" class="required px-2" item-text="name" item-value="id"
                      :items="AgencyList" :rules="rulesAgency" v-model="child.agency" return-object :disabled="session.role() !== 'admin'" @change="fetchAgencyData()" :readonly="readonly">
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-layout>
      
              <v-layout class="mt-2 flex-column">
                <!-- <v-layout wrap>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Name" v-model.trim="child.agency_contact"
                      class="px-2" @input="changedData" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Address Line 1" v-model.trim="agencyAddress.line_1"
                      class="px-2" @input="changedData($event, true)" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Address Line 2" v-model="agencyAddress.line_2" @input="changedData($event, true)"
                      class="px-2" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="City" class="px-2" v-model.trim="agencyAddress.city"
                      @input="changedData($event, true)" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-autocomplete label="Country" class="px-2" item-text="name" item-value="id" :items="Country"
                      :rules="[rules.required]" v-model="agencyAddress.country"
                      @change="changedData($event, true)" :readonly="readonly">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-autocomplete label="State" :items="filteredStates" item-value="id" item-text="name"
                      no-data-text="No data available" :rules="[rules.required]" class="px-2 required"
                      @change="changedData($event, true)" v-model="agencyAddress.state" :readonly="readonly">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Zip Code" v-mask="'#####'" placeholder="#####" v-model="agencyAddress.zip"
                      class="px-2" :rules="[rules.zipRules]" @input="changedData($event, true)" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Email Address" v-model="agencyAddress.email"
                      @blur="duplicateEmailChecking" class="required px-2"
                      :rules="[rules.required, rules.emailRules]" v-validate="'required'" data-vv-name="emailAddress"
                      @input="changedData($event, true)" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field v-mask="'(###) ###-####'" placeholder="(###) ###-####" label="Phone Number"
                      v-model="agencyAddress.phone" @input="changedData($event, true)" :rules="[rules.phoneRules]"
                      class="px-2" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="Website URL" hint="Ex: https://example.com, http://example.com"
                      v-model="agencyAddress.website" class="px-2" :rules="rules.websiteRules"
                      data-vv-name="websiteAddress" @input="changedData($event, true)" :readonly="readonly">
                    </v-text-field>
                  </v-flex>
                </v-layout> -->
                <v-layout wrap>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-model.trim="child.website_contact.name" :rules="[rules.required]" label="Contact Name" class="required px-2" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-model.trim="child.website_contact.organization" label="Organization" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-mask="'(###) ###-####'" placeholder="(###) ###-####" label="Phone Number"
                      v-model.trim="child.website_contact.phone" @input="changedData" :rules="[rules.phoneRules]" class="px-2" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field label="Email Address" v-model="child.website_contact.email" class="required px-2" :rules="[rules.required, rules.emailRules]" v-validate="'required'" data-vv-name="emailAddress" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field label="Website URL" hint="Ex: https://example.com, http://example.com" v-model="child.website_contact.website" class="px-2" :rules="rules.websiteRules" data-vv-name="websiteAddress" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>

            </v-form>
          </v-layout>

        </template>

        <template v-else-if="currentChild">
          <SingleChild
            :parentData="child"
            @onChange="changedData"
            :child="currentChild"
            @goBack="cancelViewChild"
            @onSave="saveCurrentChild"
            @onSubmit="save"
            @avatarChange="addProfileImage"
            @uploadPhotos="addImage"
            :individualPhotos="individualPhotos"
            @fetchPhotos="fetchPhotos"
            @changedChildType="changedChildType"
            @fetchChildVideos="fetchChildVideos"
            :video="video"
            :individualVideos="individualVideos"
            :getIdFromURL="getIdFromURL"
            @addVideo="addVideo"
            @editVideo="editVideo"
            :currentEditVideo="currentEditVideo"
            @cancelVideoEdit="cancelVideoEdit"
            :isVideoCaptionEdit="isVideoCaptionEdit"
            @deleteVideo="deleteVideo"
            @updateVideoTitle="updateVideoTitle"
            @agencyDataChanged="isAgencyContactInfoChanged = true"
            :videoLinkRule="videoLinkRule"
            :displayLocationsList="displayLocationsBackup"
            :inquiryList="inquiriesBackup"
            :additionalInfo="newChild.additional_info"
            :professionalContact="child.contact"
            :websiteContact="child.website_contact"
          />
        </template>

        <!-- Save/Cancel Buttons -->
        <v-layout class="mt-5" v-if="child.type !== 'Individual'">
          <v-flex xs12 class="text-xs-right">
            <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" to="/children">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn :disabled="!selectedData && groupCurrentPage === groupLastPage" class="pf-btn pf-bg-teal border-radius-10 box-shadow-none" @click="childId ? update() : save()" v-if="!readonly || groupCurrentPage !== 2">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>{{ groupCurrentPage === 2 ? 'Save' : 'Next' }}</div>
            </v-btn>
          </v-flex>
        </v-layout>

      </v-layout>
    </template>
  </div>
</template>
  
<script>
/* global session store config */
import Vue from 'vue';
import { create, getCollection, request, mergeObjects, validateUrl, getOne, checkIfNoPFUrl, update, remove, isYouTubeVideo, formatDate, isObjectEmpty, calculateAge } from '../../helpers/helpers';
import swal from 'sweetalert2';
import AppModal from '../../components/AppModal';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import generatePassword from 'generate-password';
import Editor from '@tinymce/tinymce-vue';
import SingleChild from './singleChild';
import isotope from '../../components/Isotope';
import imagesLoaded from 'vue-images-loaded';
import ChildInquiries from './Inquiries';
import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from 'vue-vimeo-player';
import { Types } from 'aws-sdk/clients/clouddirectory';


export default {
  name: 'childAdd',
  directives: { mask, imagesLoaded },
  components: {
    'app-modal': AppModal,
    Editor,
    SingleChild,
    isotope,
    imagesLoaded,
    'vimeo-player': vueVimeoPlayer,
    'child-inquiries': ChildInquiries
  },
  data: (vm) => ({

    mainTab: 'general',
    childStatuses: ['Active', 'On Hold', 'Family Matched'],
    placementTypes: [
      { text: 'In State Only', value: 'inState' },
      { text: 'No Restrictions', value: 'anyWhere' },
      { text: 'Selected States', value: 'selectedStates' }
    ],
    childId: null,
    singleChild: false,
    contactObj: {
      name: '',
      organization: '',
      phone: '',
      email: '',
      website: ''
    },
    child: {
      name: '',
      case_id: '',
      type: 'Individual',
      status: {
        status: 'Active'
      },
      description: '',
      agency: '',
      agency_contact: '',
      jurisdiction: {
        county: '',
        city: ''
      },
      preference: {
        parent_type: [],
        gender: '',
        age: '',
        other_children: '',
        religion: '',
        ethnicity: []
      },
      children: [],
      placement: 'anyWhere',
      display_on_states: []
    },
    currentChild: null,
    groupPhotos: [],
    individualPhotos: [],
    isCaptionEdit: false,
    currentEditPhoto: null,
    currentEditPhotoIndex: -1,
    editPhotoItem: null,
    video: {
      name: '', url: '', size: '', type: ''
    },
    isVideoLinkValidated: false,
    tempVideoLink: null,
    groupCurrentPage: 1,
    groupLastPage: 2,
    groupFormNames: {
      1: 'ChildInfo',
      2: 'ChildContact'
    },
    mainTabs: {
      1: 'general',
      2: 'contact'
    },
    groupVideos: [],
    individualVideos: [],
    isVideoCaptionEdit: false,
    currentEditVideo: null,
    currentEditVideoIndex: -1,
    editVideoData: {},
    readonly: false,
    displayLocationHeaders: [
      { text: 'Organization Name', value: 'organizationName', width: '20%' },
      { text: 'State', value: 'state', width: '20%' },
      { text: 'Website URL', value: 'websiteUrl', width: '20%' },
      // { text: 'Status', value: 'status', width: '20%' }
    ],
    isDisplayLocation: false,
    displayLocations: [],
    displayLocationsBackup: [],
    displayState: 'All',
    isDisplayInquiries: false,
    inquiries: [],
    inquiriesBackup: [],
    formatDate,

    selectedData: false,
    isAgencyContactInfoChanged: false,
    session: session,
    usernameFlag: false,
    emailFlag: false,
    show1: false,
    selectedTabs: ['Background Information'],
    selectedGeneralTab: 'Preferences',
    config: config,
    childrenTypes: [
      { text: 'Individual', value: 'Individual' },
      { text: 'Sibling Group', value: 'Sibling' }
    ],
    itemsPerPage: 5,
    enableMultiChild: false,
    newChildCopy: null,
    newChild: {
      case_id: '',
      about: '',
      private_information: '',
      for_professionals: '',
      human: [{
        first_name: '',
        middle_name: '',
        last_name: '',
        birth_date: '',
        age: '',
        gender: '',
        ethnicity: '',
        education: ''
      }],
      additional_info: {
        legally_free: true,
        icwa: false,
        primary_language: 'English',
        secondary_language: '',
        keep_relationships: false,
        keep_relation_person: '',
        pets: [],
        assistance_eligibility: [],
        smoke_allergy: false,
        pay_private_services: 'Check with child\'s worker',
        allergies: '',
        disability: {
          display: 'Do not display any information about disabilities or risk factors',
          risks: [],
          types: {
            'Overall level of physical disability': { value: 'None', items: [] },
            'Overall level of emotional disability': { value: 'None', items: [] },
            'Overall level of behavioral disability': { value: 'None', items: [] },
            'Overall level of developmental disability': { value: 'None', items: [] },
            'Overall level of learning disability': { value: 'None', items: [] }
          }
        }
      },
      placement: 'anyWhere',
      display_on_states: []
    },
    stateNamesArray: [],
    dobFormatted: [null],
    editorOption: {
      placeholder: 'Add text here..',
    },
    aboutContent: '',
    init: {
      height: 250,
      selector: 'blogTextEditor',
      placeholder: 'Add about child(ren) here',
      menubar: false,
      plugins: [],
      toolbar: ''
    },
    agencyAddress: {
      line_1: '',
      line_2: '',
      city: '',
      country: '',
      state: '',
      zip: '',
      email: '',
      phone: '',
      website: '',
    },
    rulesName: [
      v => !!v || 'Group name is required'
    ],
    rulesAgency: [
      v => !!v || 'Agency is required'
    ],
    membershipRules: [
      v => !!v || 'membership is required'
    ],
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ],
      caseIdRule: [
        v => !!v || 'Case ID is required.',
        // (v) => !v || vm.checkIfCaseIdUnique(v) || 'The case Id is already exists'
      ],
    },
    rulesPswd: [
      v => !!v || 'Password is required'
    ],
    emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
    ethnicities: [
      'Black/African American',
      'Asian',
      'White/Caucasian',
      'Hispanic/Latino',
      'American Indian/Alaskan Native',
      'Pacific Islander/Native Hawaiian',
      'Unable to determine'
    ],
    educations: [
      'Unknown',
      '1st Grade',
      '2nd Grade',
      '3rd Grade',
      '4th Grade',
      '5th Grade',
      '6th Grade',
      '7th Grade',
      '8th Grade',
      '9th Grade',
      '10th Grade',
      'Other'
    ],
    genders: [
      'Male',
      'Female',
      'Female to Male',
      'Male to Female',
      'In Transition',
      'Other',
      'Unknown'
    ],
    dataTabsModel: 'data-tabs-model',
    commonTabsModel: 'common-tabs-model',
    yesOrNo: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
    languages: ['English', 'Spanish', 'Russian', 'French', 'None'],
    pets: ['Cats', 'Dogs', 'Other'],
    eligibilities: [
      'Ongoing financial assistance',
      'Ongoing medical assistance',
      'Ongoing mental health assistance',
      'Non-recurring adoption costs',
      'Check with child\'s worker'
    ],
    parentTypes: ['2 parents', '1 female parent', '1 male parent'],
    otherChildren: ['No preference', 'No other children', 'Must have other children'],
    prefGenders: ['No preference', 'Male only', 'Female only'],
    prefAges: ['No preference', 'Must be oldest', 'Must be youngest'],
    prefReligions: [
      'Anglican',
      'Atheist',
      'Bahai',
      'Baptist',
      'Buddhist',
      'Catholic',
      'Christian',
      'Church of Christ',
      'Episcopal',
      'Hindu',
      'Jewish',
      'Lutheran',
      'Mormon',
      'Methodist',
      'Muslim',
      'None',
      'Non-denominational',
      'Other',
      'Presbyterian',
      'Protestant',
      'The Church of Jesus Christ of Latter-Day Saints',
      'Unitarian'
    ],
    disabilityAccess: ['Do not display any information about disabilities or risk factors', 'Display only the overall levels without specific details', 'Display everything, overall levels and specific details'],
    risks: ['Alcohol exposed', 'Domestic-violence exposed', 'Drug exposed—in home', 'Failure to thrive', 'History of abuse or neglect', 'History of multiple placements', 'Intellectual disability in birth family', 'Mental illness in birth family', 'Premature birth', 'Schizophrenia in birth family', 'Sexual abuse'],
    disabilities: [
      'Overall level of physical disability',
      'Overall level of emotional disability',
      'Overall level of behavioral disability',
      'Overall level of developmental disability',
      'Overall level of learning disability'
    ],
    disabilityTypes: ['None', 'Mild', 'Moderate', 'Severe'],
    currentChildIndex: 0,
    childTypeModal: false,
    primaryAgency: null
  }),
  computed: {
    ...mapGetters(['Agency']),
    filteredStates () {
      let countryId = this.agencyAddress.country ? this.agencyAddress.country : '5f0af2eb1b61360afbb1aa0c';
      let options = this.State;
      return countryId ? options.filter(o => o.country.id === countryId) : [];
    },
    displayedStates () {
      return this.displayLocationsBackup.filter(agency => agency.address && agency.address.length).map(agency => agency.address[0].state.name) || [];
    },
    states () {
      return this.State.filter(o => o.country.id === '5f0af2eb1b61360afbb1aa0c');
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    },
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    enterPasswordRules () {
      return [
        v => !!v || 'Field is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number'
      ];
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.readonly && this.selectedData) {
      swal.fire({
        title: 'Unsaved Changes',
        text: 'Leaving the page will remove the unsaved changes',
        showCancelButton: true,
        confirmButtonText: 'Leave',
        confirmButtonColor: '#019d8c'
      }).then((result) => {
        if (result.value) {
          next();
        } else {
          return false;
        }
      });
    } else {
      next();
    }
  },
  watch: {
    // child: {
    //   handler: function (after, before) {
    //     let self = this;
    //     after.children.map((x, i) => {
    //       self.dobFormatted[i] = self.formatDateLocal(x.human[0].birth_date);
    //       return x;
    //     });
    //   },
    //   deep: true
    // }
  },
  // eslint-disable-next-line
  async created () {
    this.newChildCopy = JSON.parse(JSON.stringify(this.newChild));
    this.child.contact = this.child.website_contact = this.contactObj;
    if (this.$route.params.id) {
      this.childId = this.$route.params.id;
      await this.fetchChildData();
      if (this.child.type === 'Individual') {
        this.singleChild = true;
      }
      /* Set readonly */
      if (this.childId && !this.Agency.is_super_admin && !this.Agency.child.find(x => x.child === this.child.id)) {
        this.readonly = true;
      }
      // Set age
      this.child.children = this.child.children.map(child => {
        if (child.human && child.human[0] && child.human[0].birth_date && typeof child.human[0].age === 'undefined') {
          child.human[0].age = calculateAge(child.human[0].birth_date);
        }
        return child;
      });

      /* Fetch the display locations and inquiries */
      this.fetchDisplayLocations();
      await this.fetchInquiries();
    } else {
      window.getApp.$emit('pageSubHeader', 'Add');
      if (this.child.type === 'Individual') {
        this.child.children = [{ ...this.newChild, ...this.contactObj, ...this.child.preference }];
      }
    }

    this.setProfessionalContact();
    this.setWebsiteContact();

    /* Set the agency id */
    if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
      this.child.agency = { id: this.Agency._id, name: this.Agency.name };
    }
    await this.fetchAgencyData();

    if (this.child.type === 'Individual') {
      this.currentChild = this.child.children[0];
      this.currentChild.agencyAddress = this.agencyAddress;
      this.currentChildIndex = 0;
      await this.fetchPhotos('individual');
      await this.fetchChildVideos('individual');
    } else {
      await this.fetchPhotos('group');
      await this.fetchChildVideos('group');
    }
    this.initialize();
    this.initializeCountry();
    this.initializeState();
    this.child.password = generatePassword.generate({
      length: 8,
      uppercase: true,
      numbers: true,
      lowercase: true,
      strict: true
    });
    if ([true, 'true'].includes(this.$route.query.showDisplayLocations)) {
      this.showDisplayLocations();
    } else if ([true, 'true'].includes(this.$route.query.showInquiries)) {
      this.showInquiries();
    }

  },
  mounted () {
    window.getApp.$on('NEW_ALBUM_PHOTO', messageEvent => {
      console.log('------------>>>>>>>', 'Album Photo', messageEvent);
      if (messageEvent.data) {
        const newImage = messageEvent.data;
        
        if (!this.groupPhotos.find(item => item.id === newImage.id)) {
          this.groupPhotos.push(newImage);
        }
      }
    });
  },
  methods: {
    setProfessionalContact () {
      if (!isObjectEmpty(this.child.contact)) {
        return;
      }
      if (this.child.agency && this.child.agency.professional_contacts && this.child.agency.professional_contacts.length && !isObjectEmpty(this.child.agency.professional_contacts[0])) {
        this.child.contact = { ...this.child.agency.professional_contacts[0] };
        return;
      }
      const canUseOwnDetails = !this.child.id || (this.child.id && this.Agency.child.find(x => x.child === this.child.id));
      if (canUseOwnDetails && !this.Agency.is_super_admin && this.Agency.professional_contacts && this.Agency.professional_contacts.length && !isObjectEmpty(this.Agency.professional_contacts[0])) {
        this.child.contact = { ...this.Agency.professional_contacts[0] };
        return;
      }
      this.child.contact = this.contactObj;
    },
    setWebsiteContact () {
      const isNotOwner = this.child.id && !this.Agency.child.find(x => x.child === this.child.id);
      if (isNotOwner || isObjectEmpty(this.child.website_contact)) {
        if (!this.Agency.is_super_admin) {
          if (this.Agency.website_contacts && this.Agency.website_contacts.length && !isObjectEmpty(this.Agency.website_contacts[0])) {
            this.child.website_contact = { ...this.Agency.website_contacts[0] };
          } else {
            this.child.website_contact = {
              name: this.Agency.contact_name || '',
              email: this.Agency.email && this.Agency.email.length ? this.Agency.email[0].email : '',
              phone: this.Agency.phone && this.Agency.phone.length ? this.Agency.phone[0].number : '',
              website: this.Agency.website || '',
              organization: this.Agency.name
            };
          }
        } else {
          if (this.child.agency && this.child.agency.website_contacts && this.child.agency.website_contacts.length && !isObjectEmpty(this.child.agency.website_contacts[0])) {
            this.child.website_contact = { ...this.child.agency.website_contacts[0] };
          }
        }
      }
      // Use default if still empty
      if (isObjectEmpty(this.child.website_contact)) {
        this.child.website_contact = this.contactObj;
      }
    },
    // @vuese
    // Used to initialize the agency list if not exists.
    async initialize () {
      let where = { /* _id: { $ne: this.Agency.id }, */ is_admin: false };
      let attributes = 'name,nickname,email,address,createdAt,mapping_id,map_sub_id';
      let populate = [{ path: 'human', select: '_id user' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load client list'
        };
      } else {
        if (data.length) {
          store.commit('setAgencyList', data);
        }
      }
    },
    async fetchChildData () {
      if (this.childId) {
        let populate = [{ path: 'child.child', populate: { path: 'human' }}, { path: 'agency', select: 'name website status website_contacts professional_contacts', populate: [{ path: 'address.state', select: 'name' }] }];
        let { error, data } = await getOne('ChildGroup', this.childId, populate);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load child data'
          };
        } else {
          this.primaryAgency = data.agency ? JSON.parse(JSON.stringify(data.agency)) : null;
          data.children = data.child.map(x => x.child);
          delete data.child;
          this.child = mergeObjects(data, this.child);
          window.getApp.$emit('pageSubHeader', this.child.name);
        }
      }
    },
    async fetchChildVideos (type) {
      let where = {};
      if (type === 'group') {
        where.child_group = this.child.id;
      } else {
        where.child = this.currentChild.id;
      }
      let { error, data } = await getCollection('Video', true, 0, '', where);
      this[`${type}Videos`] = data;
    },
    editVideo (item, id) {
      this.currentEditVideo = item.id;
      this.isVideoCaptionEdit = true;
      this.editVideoData = item;
      this.currentEditVideoIndex = this.groupVideos.indexOf(item);
    },
    cancelVideoEdit () {
      this.isVideoCaptionEdit = false;
      this.currentEditVideo = null;
      this.currentEditVideoIndex = null;
      this.editVideoData = {};
    },
    async updateVideoTitle (type = 'group') {
      if (this.editVideoData.id) {
        let { error, data, status } = await update('Video', this.editVideoData, this.editVideoData.id);
        if (error) {
          console.log('error', error);
        } else {
          this[`${type}Videos`][this.currentEditorIndex] = data;
        }
      }
    },
    deleteVideo (item, type = 'group') {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Video', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this[`${type}Videos`].indexOf(item);
              this[`${type}Videos`].splice(index, 1);
              let deletedVideoItem = this[`${type === 'group' ? 'child' : 'currentChild'}`].video.find(video => video.video === item.id);
              this[`${type === 'group' ? 'child' : 'currentChild'}`].video.splice(this[`${type === 'group' ? 'child' : 'currentChild'}`].video.indexOf(deletedVideoItem), 1);
              swal.fire(
                'Deleted!',
                'The video has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    async fetchAgencyData () {
      if (this.child.agency) {
        let attributes = 'name address phone email createdAt';
        let { error, data } = await getOne('Agency', this.child.agency.id, '', attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch agency contact information'
          };
        } else {
          this.selectedAgency = data;
          if (this.child.agency) {
            if (data.address && data.address.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{
                  ...data.address[0],
                  ...{ country: data.address[0].country ? data.address[0].country.id : '' },
                  ...{ state: data.address[0].state ? data.address[0].state.id : '' },
                }
              };
            }
            if (data.email && data.email.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ email: data.email[0].email }
              };
            }
            if (data.phone && data.phone.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ phone: data.phone[0].number }
              };
            }
            if (data.website) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ website: data.website }
              };
            }
            if (!this.agencyAddress.country) {
              this.agencyAddress.country = '5f0af2eb1b61360afbb1aa0c';
            }
          }
        }
      }
    },
    async fetchDisplayLocations () {
      if (this.child.id) {
        let where = {
          'other_children.child': this.child.id
        };
        let populate = [{ path: 'address.state', select: 'name' }];
        let sort = { 'name': 1 };
        let attributes = '-child,-account';
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes, null, sort);
        if (error) {
          console.log(error);
        } else {
          // Add heart gallery of america
          if (this.$route.params.id) {
            data.unshift({
              name: 'Heart Gallery of America',
              id: config.admin.id,
              website: 'www.heartgalleryofamerica.org',
              other_children: [{
                status: 'Enabled',
                child: this.child.id
              }],
              is_owner: true
            });
          }
          // Add the child primary organization
          data.unshift({
            ...this.primaryAgency,
            other_children: [{
              status: 'Enabled',
              child: this.child.id
            }],
            is_owner: true
          });
          this.displayLocations = data;
          this.displayLocationsBackup = JSON.parse(JSON.stringify(this.displayLocations));
        }
      }
    },
    async fetchInquiries () {
      if (this.child.children && this.child.children.length && this.child.children[0].map_data) {
        let where = {
          childId: this.child.children.filter(x => x.map_data && x.map_data.user_id).map(x => x.map_data.user_id).join(','),
          agency: this.child.agency.id
        };
        let { error, data } = await getCollection('ChildGroup/Inquiries', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.inquiries = data;
          this.inquiriesBackup = JSON.parse(JSON.stringify(this.inquiries));
        }
      }
    },
    showInquiries () {
      this.isDisplayInquiries = true;
    },
    showDisplayLocations () {
      this.isDisplayLocation = true;
    },
    filterDisplayLocations () {
      if (this.displayState) {
        if (this.displayState === 'All') {
          this.displayLocations = JSON.parse(JSON.stringify(this.displayLocationsBackup));
        } else {
          this.displayLocations = this.displayLocationsBackup.filter(x => x.address && x.address.length && x.address[0].state && this.displayState === x.address[0].state.name);
        }
      }
    },
    async changeDisplayStatus (item) {
      if (this.readonly) {
        return;
      }
      const payload = JSON.parse(JSON.stringify(item));
      payload.updated_from = 'childBadge';
      let { error: updateError, data: updateData, status: updateStatus } = await update('Agency', payload, payload.id);
      if (updateError) {
        console.log('updateError', updateError);
      }
    },
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
            data.forEach(element => {
              this.stateNamesArray.push(element.name);
            });
          }
        }
      }
    },
    addProfileImage (type) {
      const client = global.filestack.init(config.filestack.client);
      const folderName = this.child.children[0].human[0].id;
      let albumId = this.singleChild ? this.currentChild.avatar_album : this.child.avatar_album;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: 300 / 228, force: true }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + folderName + '/avatar/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          if (type === 'individual' && filename.indexOf('_siblingavatar_') > -1) {
            filename = filename.replace('_siblingavatar_', '');
          }
          return { name: filename + (type === 'individual' ? '_siblingavatar_' : '') + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          if (response.filesUploaded && response.filesUploaded.length) {
            let original_url = config.s3BucketPath + response.filesUploaded[0].key;
            let avatarThumb = original_url;
            if (type === 'group') {
              this.child.avatar = avatarThumb;
            } else {
              this.currentChild.avatar = avatarThumb;
              this.child.children[this.currentChildIndex].avatar = avatarThumb;
              this.child.avatar = avatarThumb;
            }
          }
        },
        
      };
      client.picker(options).open();
    },
    getIdFromURL (url) {
      let a = url.split('/embed/')[1];
      return a;
    },
    videoLinkRule (url) {
      if (!this.isVideoLinkValidated) {
        if (url !== undefined && url !== '') {
          let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
          let match = url.match(regExp);
          if (match && match[2].length === 11) {
            this.tempVideoLink = url;
            return false;
          }
          else {
            let regExp2 = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
            let match2 = url.match(regExp2);
            if (match2) {
              this.tempVideoLink = 'https://player.vimeo.com/video/' + match2[3];
              return false;
            } else {
              return 'Please enter a video url';
            }
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    layout () {
      if (this.$refs.groupImages) {
        this.$refs.groupImages.layout('masonry');
      }
    },
    getOptions () {
      return {
        layoutMode: 'masonry',
        masonry: {
          columnWidth: '.photo-item',
        },
        percentPosition: true,
        originLeft: true,
        itemSelector: '.photo-item'
      };
    },
    async fetchPhotos (type) {
      let albumId = type === 'group' ? this.child.group_album : this.currentChild.individual_album;
      if (albumId) {
        let { error, data } = await getOne('Album', albumId);
        this[`${type}Photos`] = data.photo.map(photo => photo.photo);
      }
    },
    async addImage (type) {
      const client = global.filestack.init(this.config.filestack.client);
      const humanId = type === 'group' ? this.child.children[0].human[0].id : this.currentChild.human[0].id;
      let albumId = type === 'group' ? this.child.group_album : this.currentChild.individual_album;
      if (!albumId) {
        /* Create the album */
        let albumDocument = {
          name: `${type === 'group' ? 'Group' : 'Individual'} Images`,
          type: 'Profile'
        };
        if (type === 'group') {
          albumDocument.child_group = this.child.id;
        } else {
          albumDocument.child = this.currentChild.id;
        }
        let { error: albumError, data: albumData } = await create('Album', albumDocument);
        if (albumError) {
          console.log(albumError);
        } else {
          albumId = albumData.id;
          if (type === 'group') {
            this.child.group_album = albumData.id;
          } else {
            this.child.children[this.currentChildIndex].individual_album = albumData.id;
            this.currentChild.individual_album = albumData.id;
          }
        }
      }
      if (!albumId) {
        swal.fire({
          type: 'warning',
          text: 'Failed to create an album, please try again',
          timer: 2500
        });
        return;
      }
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 20,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        storeTo: {
          location: 'S3',
          path: '/' + this.config.s3Domain + '/' + humanId + '/album/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: async (response) => {
          /*  */
        }
      };
      client.picker(options).open();
    },
    editPhotoCaption (item, index) {
      this.currentEditPhotoIndex = index;
      this.currentEditPhoto = item.id;
      this.isCaptionEdit = true;
      this.editPhotoItem = item;
    },
    async savePhotoCaption () {
      if (this.currentEditPhotoIndex > -1) {
        let { error, data, status } = await update(
          'Photo',
          this.editPhotoItem,
          this.editPhotoItem.id
        );
        if (error) {
          console.log('error', error);
        } else {
          if (this.child.type === 'Sibling') {
            this.groupPhotos[this.currentEditPhotoIndex] = data;
          }
          this.removePhotoCaptionEdit();
        }
      }
    },
    removePhotoCaptionEdit () {
      this.currentEditPhotoIndex = -1;
      this.currentEditPhoto = null;
      this.isCaptionEdit = false;
      this.editPhotoItem = null;
    },
    async deletePhoto (item) {
      swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Photo', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const photosArray = this.child.type === 'Sibling' ? 'groupPhotos' : 'individualPhotos';
              const photoIndex = this[photosArray].findIndex(x => x.id === item.id);
              if (photoIndex > -1) {
                this[photosArray].splice(photoIndex, 1);
              }
            }
          })();
        }
      });
    },
    async duplicateEmailChecking () {
      if (this.child.email && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/).test(this.child.email.trim())) {
        swal.fire({
          title: 'Please enter a valid email address',
          type: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close',
          allowOutsideClick: false
        });
        return false;
      }
      this.emailFlag = false;
      if (this.agencyAddress.email.length) {
        const emailUrl = `${this.config.WPParams.api.url}pf/v1/emailexists?email=${this.agencyAddress.email}`;
        let where = { 'username': this.agencyAddress.email.trim() };
        const response = await getCollection('User', true, 0, '', where);
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.data && response.data.length) {
            swal.fire({
              title: 'The email already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              this.agencyAddress.email = '';
            });
          } else {
            this.emailFlag = true;
          }
        }
      }
    },
    switchTabs (tab, page) {
      if (page === this.groupCurrentPage) {
        return;
      }
      const formValid = this.readonly || this.$refs[this.groupFormNames[this.groupCurrentPage]].validate();
      if (page && formValid) {
        if (this.child.type === 'Sibling' && this.child.children.length < 2) {
          swal.fire({
            type: 'warning',
            html: `Please add at least 2 children for sibling group`,
            showConfirmButton: true
          });
          return;
        } else {
          this.groupCurrentPage = page;
          this.mainTab = tab;
        }
      } else if (!formValid) {
        swal.fire({
          type: 'warning',
          text: 'Please make sure you filled all the mandatory fields',
          showConfirmButton: true
        });
        return;
      }
    },
    // eslint-disable-next-line complexity
    async save (singleChildData) {
      let formValid = true;
      /* Populate the common group fields from single child if Individual */
      if (this.child.type === 'Individual' && singleChildData) {
        if (singleChildData.contact) {
          this.child.contact = singleChildData.contact;
        }
        if (singleChildData.website_contact) {
          this.child.website_contact = singleChildData.website_contact;
        }
        if (singleChildData.preference) {
          this.child.preference = singleChildData.preference;
        }
        if (singleChildData.placement) {
          this.child.placement = singleChildData.placement;
        }
        if (singleChildData.display_on_states) {
          this.child.display_on_states = singleChildData.display_on_states;
        }
        this.child.case_id = singleChildData.case_id;
        this.child.description = singleChildData.about;
        this.child.children[0] = singleChildData;

        if (this.childId) {
          this.update();
          return;
        }

      } else {

        formValid = this.$refs[this.groupFormNames[this.groupCurrentPage]].validate();
        if (formValid && this.groupCurrentPage === this.groupLastPage) {
          /* Check if atleast a child exists */
          if (!this.child.children.length) {
            formValid = false;
            swal.fire({
              type: 'warning',
              html: `Please add at least ${this.child.type === 'Individual' ? 'one child' : 'two children'}`,
              showConfirmButton: true
            });
            return;
          }
          if (!this.child.children[0].human[0].first_name) {
            formValid = false;
            swal.fire({
              type: 'warning',
              html: `Please fill the child information`,
              showConfirmButton: true
            });
            return;
          }
          if (!this.child.agency) {
            formValid = false;
            swal.fire({
              type: 'warning',
              html: `Plase choose an organization under contact`,
              showConfirmButton: true
            });
            return;
          }
        }
      }

      if (formValid) {

        if (this.child.type === 'Sibling' && this.child.children.length < 2) {
          swal.fire({
            type: 'warning',
            html: `Please add at least 2 children for sibling group`,
            showConfirmButton: true
          });
          return;
        }

        if (!!singleChildData || this.groupCurrentPage === this.groupLastPage) {

          if (this.readonly) {
            return;
          }

          if (this.child.type === 'Individual') {
            this.child.name = this.child.children[0].human[0].first_name;
          }
  
          /* Update the names */
          this.child.children = this.child.children.map(c => {
            c.name = c.human[0].first_name;
            return c;
          });
  
          let payload = JSON.parse(JSON.stringify(this.child));
          
          /* Set the username */
          payload.username = (payload.children.map(c => c.human[0].first_name.trim())).join('') + (new Date()).getTime();

          payload.agency = payload.agency.id;
  
          let response = await request('Child/Register', 'POST', payload);
  
          if (response.error) {
            console.log('error', response.error);
            swal.fire({
              type: 'warning',
              title: '<b>Error</b>',
              html: response.message,
              showConfirmButton: true,
              onClose: () => {
                // 
              }
            });
          } else {
            this.Agency.child.push({ child: response.data._id, createdAt: response.data.agency[0].createdAt, updatedAt: response.data.agency[0].updatedAt });
  
            if (this.isAgencyContactInfoChanged) {
              /* Save the agency contact info */
              await this.agencyUpdate();
            }
  
            swal.fire({
              type: 'success',
              title: '<b>Success</b>',
              html: response.message,
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.selectedData = false;
                this.$router.push({ path: '/children', query: { requestFrom: 'update' }});
              }
            });
          }

        } else {
          this.groupCurrentPage++;
          this.mainTab = this.mainTabs[this.groupCurrentPage];
        }

      } else {
        swal.fire({
          type: 'warning',
          text: 'Please make sure you filled all the mandatory fields for all the children'
        });
        return;
      }
    },
    // eslint-disable-next-line complexity
    async update (isBG = false) {
      let formValid = true;

      formValid = this.child.type === 'Individual' || this.$refs[this.groupFormNames[this.groupCurrentPage]].validate();

      if (formValid && this.groupCurrentPage === 1) {
        /* Check if atleast a child exists */
        if (!this.child.children.length) {
          formValid = false;
          swal.fire({
            type: 'warning',
            html: `Please add at least ${this.child.type === 'Individual' ? 'one child' : 'two children'}`,
            showConfirmButton: true
          });
          return;
        }
        if (!this.child.children[0].human[0].first_name) {
          formValid = false;
          swal.fire({
            type: 'warning',
            html: `Please fill the child information`,
            showConfirmButton: true
          });
          return;
        }
        if (!this.child.agency) {
          formValid = false;
          swal.fire({
            type: 'warning',
            html: `Plase choose an organization under contact`,
            showConfirmButton: true
          });
          return;
        }
      }
      /* Do not allow sibling with single child */
      if (this.child.type !== 'Individual' && this.child.children.length <= 1) {
        formValid = false;
        swal.fire({
          type: 'warning',
          html: `Please add more child(ren) or change type to Individual`,
          showConfirmButton: true
        });
        return;
      }
      if (formValid) {

        if (this.child.type === 'Individual' || this.groupCurrentPage === this.groupLastPage) {

          if (this.readonly) {
            return;
          }

          let isError = false;
          const children = JSON.parse(JSON.stringify(this.child.children));
  
          for (let i = 0; i < children.length; i++) {
  
            let child = JSON.parse(JSON.stringify(children[i]));
  
            if (child && child.id) {
              if (this.child.type === 'Individual' && i > 0) {
                /* Remove the child and human - less chance */
                let { error: removeError, data: removeData, status: removeStatus } = await remove('Child', child.id);
                // eslint-disable-next-line
                if (removeError) {
                  console.log('removeError', removeError);
                  isError = true;
                } else {
                  await remove('Human', child.human[0].id);
                  this.child.children.splice(i, 1);
                }
              } else {
                let payload = JSON.parse(JSON.stringify(child));
                payload.name = payload.human[0].first_name;
                payload.human = payload.human.map(x => x.id);
                let { error: updateError, data: updateData, status: updateStatus } = await update('Child', payload, payload.id);
                // eslint-disable-next-line
                if (updateError) {
                  console.log('updateError', updateError);
                  isError = true;
                } else {
                  // this.child.children[i] = updateData;
                  let humanData = child.human[0];
                  humanData.ethnicity = humanData.ethnicity || '';
                  humanData.education = humanData.education || '';
                  humanData.religion = humanData.religion || '';
                  await update('Human', humanData, humanData.id);
                }
              }
            } else {
              /* Create the account and human */
              let human = child.human[0];
              human.child = this.child.id;
              let { error: createError, data: createData, status: createStatus } = await create('Human', human);
              if (createError) {
                console.log('createError', createError);
                isError = true;
              } else {
                child.nickname = child.human[0].first_name.trim() + (new Date()).getTime();
                child.name = child.human[0].first_name;
                child.human = [createData.id];
                let { error: childError, data: childData, status: childStatus } = await create('Child', child);
                // eslint-disable-next-line
                if (!childError) {
                  this.child.children.push(childData);
                }
              }
            }
          }
  
          if (this.child.type === 'Individual') {
            this.child.name = this.child.children[0].human[0].first_name;
          }
  
          // Update the child group
          this.child.updated_from = 'childInfo';
          let updatePayload = JSON.parse(JSON.stringify(this.child));
          updatePayload.child = updatePayload.children.filter(child => child && child._id).map(child => {
            return {
              child: child._id
            };
          });
          delete updatePayload.children;

          updatePayload.agency = updatePayload.agency.id;
  
          let childUpdate = await update('ChildGroup', updatePayload, updatePayload.id);
          let error = childUpdate.error;
          let data = childUpdate.data;
          let status = childUpdate.status;
          if (error) {
            console.log('error', error);
            isError = true;
          }
          // Show the resultant response to the user
          if (isError) {
            this.selectedData = true;
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Unable to save the data, please try again.'
            };
          } else {
            if (this.isAgencyContactInfoChanged) {
              /* Save the agency contact info */
              await this.agencyUpdate();
            }
            if (!isBG) {
              swal.fire({
                type: 'success',
                title: 'Child information updated successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.selectedData = false;
                  this.$router.push({ path: `/children`, query: { requestFrom: 'update' }});
                }
              });
            }
          }

        } else {
          this.groupCurrentPage++;
          this.mainTab = this.mainTabs[this.groupCurrentPage];
        }

      } else if (!formValid) {
        swal.fire({
          type: 'warning',
          title: 'Incomplete',
          text: 'Please make sure you filled all the mandatory fields for all the children',
          showConfirmButton: true,
          onClose: () => {
            return;
          }
        });
      }
    },
    async agencyUpdate () {
      if (this.isAgencyContactInfoChanged) {
        let payload = JSON.parse(JSON.stringify(this.child.agency));
        if (!payload.address || !payload.address.length) {
          payload.address = [{}];
        }
        payload.address[0].line_1 = this.agencyAddress.line_1;
        payload.address[0].line_2 = this.agencyAddress.line_2;
        payload.address[0].country = this.agencyAddress.country;
        payload.address[0].zip = this.agencyAddress.zip;
        payload.address[0].state = this.agencyAddress.state;
        payload.address[0].city = this.agencyAddress.city;
        payload.website = this.agencyAddress.website;
        if (!payload.email || !payload.email.length) {
          payload.email = [{}];
        }
        payload.email[0].email = this.agencyAddress.email;
        payload.updated_from = 'childBadge';

        let updateResponse = await update('Agency', payload, payload.id);
      }
    },
    getSiblingInquiryCount () {
      const inquiries = this.inquiriesBackup.filter(x => x.is_sibling);
      if (inquiries.length) {
        // Define a Set to store unique values
        const uniqueValuesSet = new Set();
        // Iterate through the array and add unique values to the Set
        for (const obj of inquiries) {
          uniqueValuesSet.add(obj.uuid);
        }
        // Get the count of unique values
        const uniqueValuesCount = uniqueValuesSet.size;
        return uniqueValuesCount;
      }
      return 0;
    },
    getSiblingInquiries () {
      const inquiries = this.inquiriesBackup.filter(x => x.is_sibling);
      if (inquiries.length) {
        // Define a Set to store unique values
        const uniqueValuesSet = [];
        const uniqueInquiries = [];
  
        // Iterate through the array and add unique values to the Set
        for (const obj of inquiries) {
          if (obj.uuid) {
            if (uniqueValuesSet.indexOf(obj.uuid) === -1) {
              uniqueValuesSet.push(obj.uuid);
              uniqueInquiries.push(obj);
            }
          } else {
            uniqueInquiries.push(obj);
          }
        }
        return uniqueInquiries;
      }
      return [];
    },
    placementChanged () {
      if (['inState', 'selectedStates'].indexOf(this.child.placement) > -1 && this.agencyAddress.state) {
        const state = this.filteredStates.find(x => x.id === this.agencyAddress.state);
        if (state) {
          this.child.display_on_states = [state.id];
        }
      } else if (this.child.placement === 'anyWhere') {
        this.child.display_on_states = [];
      }
      this.changedData();
    },
    changedData (e, isAgencyContactInfoChanged = false) {
      this.selectedData = true;
      if (isAgencyContactInfoChanged) {
        this.isAgencyContactInfoChanged = isAgencyContactInfoChanged;
      }
    },
    formatDateLocal (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    getAgencyState (inquiry) {
      if (inquiry && inquiry.badge_identifier) {
        const agency = this.AgencyList.filter(x => x.map_sub_id).find(x => x.map_sub_id.toString() === inquiry.badge_identifier.toString());
        return agency && agency.address && agency.address.length ? (agency.address[0].state && agency.address[0].state.name ? agency.address[0].state.name : '--') : '--';
      }
      return '--';
    },
    addChild () {
      const child = { ...this.newChildCopy, ...{ picker: false }};
      this.child.children.push(child);
      this.dobFormatted.push(null);
      this.currentChild = child;
      this.viewChild(child, this.child.children.length - 1);
    },
    viewChild (item, index) {
      if (item && index > -1) {
        this.currentChildIndex = index;
        this.currentChild = item;
        this.singleChild = true;
        this.currentChild.agencyAddress = this.agencyAddress;
      }
    },
    changedChildType () {
      if (this.child.type === 'Individual') {
        this.child.children = this.child.children.length ? [this.child.children[0]] : [this.newChild];
        this.currentChild = this.child.children[0];
        this.currentChildIndex = 0;
      } else {
        this.currentChild = null;
        this.currentChildIndex = 0;
      }
    },
    cancelViewChild (oldData, wasChanged = true) {
      if (wasChanged && oldData && this.currentChildIndex > -1) {
        this.child.children[this.currentChildIndex] = oldData;
      } else if (!wasChanged) {
        this.child.children.splice(this.currentChildIndex, 1);
      }
      this.currentChild = null;
      this.singleChild = false;
    },
    saveCurrentChild (updatedData) {
      if (updatedData && (this.currentChildIndex > -1 || this.child.type === 'Individual')) {
        this.child.children[this.child.type === 'Individual' ? 0 : this.currentChildIndex] = updatedData;
      }
      this.selectedData = true;
      this.cancelViewChild();
    },
    removeChild (index) {
      let self = this;
      swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure that you want to remove this child?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            if (index > -1 && self.child.children[index]) {
              self.changedData();
              self.child.children.splice(index, 1);
              self.dobFormatted.splice(index, 1);
            }
          })();
        }
      });
    },
    async addVideo (isValidated = false) {
      if (isValidated || this.$refs.videoAddForm.validate()) {
        
        this.video.type = isYouTubeVideo(this.tempVideoLink) ? 'Youtube' : 'Vimeo';

        /* Check if the vimeo video is publicly accessible */
        if (this.video.type === 'Vimeo') {
          let regExp = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
          let videoParts = this.video.url.match(regExp);
          let videoId = null;
          if (videoParts && videoParts[3]) {
            videoId = videoParts[3];
          }
          if (videoId) {
            let accessibility = await request(`Video/VimeoData/${videoId}`, 'GET');
            let message = null;
            if (!accessibility || accessibility.error) {
              message = 'Failed to fetch the video details, please try again.';
            } else if (accessibility.data && accessibility.data.privacy && ['anybody', 'unlisted'].indexOf(accessibility.data.privacy.view) === -1) {
              message = 'The video is not public, please change the video privacy and try again.';
            }
            if (message) {
              swal.fire({
                type: 'warning',
                title: 'Video Error',
                text: message,
                showConfirmButton: true
              });
              return;
            }
          }
        }
        this.video.url = this.tempVideoLink;
        this.isVideoLinkValidated = true;
        if (this.singleChild) {
          this.video.child = this.currentChild._id;
        } else {
          this.video.child_group = this.child._id;
        }
        let { error, data, status } = await create('Video', this.video);
        if (error) {
          console.log('error', error);
          swal.fire({
            type: 'warning',
            text: 'Failed to add the video',
            timer: 2500
          });
          return;
        } else {
          if (this.singleChild) {
            if (!this.individualVideos.length) {
              this.currentChild.default_video = data.id;
            }
            this.individualVideos.unshift(data);
            this.currentChild.video.push({
              sort_no: this.currentChild.video.length,
              video: data.id
            });
            this.child.children[this.currentChildIndex] = this.currentChild;
          } else {
            this.groupVideos.unshift(data);
            this.child.default_video = data.id;
            this.child.video.push({
              sort_no: this.child.video.length,
              video: data.id
            });
          }
          this.video = { name: '', url: '', size: '', type: '' };
          this.tempVideoLink = null;
          this.isVideoLinkValidated = false;
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>

.avatar-overlay {
  
    width: 100%;
    height: 100%;
    background:#00000059;
    position: absolute;
    top: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

  .title-display{
    padding-top: 6px !important;
  }
  .text-edit-field {
    padding-left: 4px;
    padding-bottom: 6px;
  }
  @media(max-width:576px){
    .or-label{
      padding-top: 0;
    }
  }

.rounded-corner {
    border-radius: 2px;
    border : 2px solid #019d8c !important;
}

.video-listing >>> .youtube-player {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}

.video-listing >>> .youtube-player iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>


// WEBPACK FOOTER //
// src/pages/Children/child.vue